import React from "react";
import "./GetMusicOnHuawei.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnHuawei = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music",
    "Select Huawei Music distribution",
    "Music delivered to Huawei ecosystem",
    "Reach millions of Huawei users",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>Huawei Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music to Huawei Music with FT Tunes. Reach global listeners across Huawei devices and streaming platforms."
        />

        <meta
          name="keywords"
          content="Huawei Music distribution, Huawei music upload, Huawei streaming platform"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="huawei-page">

        {/* HERO */}
        <section className="huawei-hero">
          <Container>

            <img
              src="/Images/huawei-logo.png"
              alt="Huawei"
              className="huawei-logo"
            />

            <h1>Distribute Your Music on Huawei Music</h1>

            <p>
              Reach millions of listeners worldwide through Huawei Music.
              Expand your audience across smartphones, tablets,
              smart devices and global markets.
            </p>

            <Button
              className="gradient-btn-huawei"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-huawei"></div>
        </section>


        {/* SHOWCASE */}
        <section className="huawei-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Huawei Global Ecosystem</h2>

                <p>
                  Huawei Music connects artists with millions of users
                  across Asia, Europe and emerging markets.
                  Deliver your music professionally and grow
                  your global fanbase.
                </p>

                <Button
                  className="outline-btn-huawei"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-huawei.png"
                  alt="Huawei Music"
                  className="huawei-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="huawei-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-huawei">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="huawei-benefits">
          <Container>

            <h2 className="section-title">
              Why Release Music on Huawei
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-huawei">
                  <h5>Massive Device Reach</h5>
                  <p>Access millions of Huawei users worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-huawei">
                  <h5>Global Streaming</h5>
                  <p>Expand into international markets.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-huawei">
                  <h5>Premium Audio Delivery</h5>
                  <p>High-quality music distribution.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-huawei">
                  <h5>Artist Revenue</h5>
                  <p>Earn from streams worldwide.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="huawei-cta">
          <Container>

            <h2>Start Releasing on Huawei Music Today</h2>

            <Button
              className="gradient-btn-huawei big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnHuawei;